import { useState, useEffect, useMemo } from "react";
import axios from "../config/axios";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ScrollToTop from "../components/common/ScrollToTop";
import MealCard from "../components/mealsPartials/MealCard";
import { useGeneral } from "../components/contexts/GeneralContext";
import ApiErrorMessage from "../components/common/ApiErrorMessage";
import NoItemsFound from "../components/common/NoItemsFound";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";
const useMealsPageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState([]);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const { data } = await axios.get("get-meals");
        if (active) setContent(data);
      } catch (err) {
        console.error(err);
        if (active) setError("Failed to load plans. Please try again later.");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return { content, loading, error, discountCoupons };
};

const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};

const MealsPage = () => {
  const { content, loading, error, discountCoupons } = useMealsPageContent();
  useScrollToTop();
const mealCards = useMemo(() => {
  const opacitySteps = [0.2, 0.4, 0.6, 0.4];

  return content.map((item, index) => {
    const opacity = opacitySteps[index % opacitySteps.length];
    return (
      <MealCard
        key={index}
        item={item}
        opacity={opacity}
      />
    );
  });
}, [content]);

  return (
    <>
      {loading && <FullScreenLoading />}
      <PageWrapper  loading={loading} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper loading={loading} className="">
          {error ? (
            <ApiErrorMessage
              message1="Failed to load meals"
              message2="Please check your connection and try again."
            />
          ) : content.length === 0 ? (
            <NoItemsFound
              message1="No meals available"
              message2="Please check back later."
            />
          ) : (
            <div className="grid grid-cols-1 gap-4 lg:gap-10 items-start">
              {mealCards}
            </div>
          )}
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default MealsPage;
